module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-picker"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Picker")]), _vm._v(" "), _c('div', {
    staticClass: "page-picker-wrapper"
  }, [_c('mt-picker', {
    attrs: {
      "slots": _vm.yearSlot,
      "visible-item-count": 3
    },
    on: {
      "change": _vm.onYearChange
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "page-picker-desc"
  }, [_vm._v("出生年份: " + _vm._s(_vm.year))]), _vm._v(" "), _c('div', {
    staticClass: "page-picker-wrapper"
  }, [_c('mt-picker', {
    attrs: {
      "slots": _vm.dateSlots,
      "visible-item-count": 3
    },
    on: {
      "change": _vm.onDateChange
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "page-picker-desc"
  }, [_vm._v("在校时间: " + _vm._s(_vm.dateStart) + " 至 " + _vm._s(_vm.dateEnd))]), _vm._v(" "), _c('div', {
    staticClass: "page-picker-wrapper"
  }, [_c('mt-picker', {
    attrs: {
      "slots": _vm.addressSlots,
      "visible-item-count": 5
    },
    on: {
      "change": _vm.onAddressChange
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "page-picker-desc"
  }, [_vm._v("地址: " + _vm._s(_vm.addressProvince) + " " + _vm._s(_vm.addressCity))]), _vm._v(" "), _c('div', {
    staticClass: "page-picker-wrapper"
  }, [_c('mt-picker', {
    attrs: {
      "slots": _vm.numberSlot,
      "visible-item-count": 3
    },
    on: {
      "change": _vm.onNumberChange
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "page-picker-desc"
  }, [_vm._v("动态默认选项\u001b: " + _vm._s(_vm.number))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-013b557c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/picker.vue
// module id = 262
// module chunks = 0